/* eslint-disable */

import { AddOn } from './AddOn';
//import * as wording from '../../../common/js/wording'
import { AddOnType } from '../FbbEnum';
import * as log from '../../../common/js/appLogger';

/*
Pls submit “Z,1” for equipList plus below values (like Norton):

WiFi路由器	VAS Code	標準月費	Mktg code	收費總額	合約期(月)	合約代號	T&C
Asus RT-AC68U	FBRM1	$40	MVZ08	$960	24	LDJ24M40	N003PB
*/
export class AddOnRouter extends AddOn {
	protected baseVasCode: String = 'ROUTER-BUY';

	constructor() {
		super();
		this.key = 'AddOnRouter';

		this.boxIconEn = '';
		this.boxIconZh = '';
		this.boxNameEn = 'Router';
		this.boxNameZh = 'Router';
		this.boxAmount = 2998;
		this.discountAmount = 2160;
		this.hasRedCounter = false;

		this.type = AddOnType.SINGLE;
	}

	public getBaseVasCode(): String {
		return this.baseVasCode || '';
	}

	public isAddOnSelected(): boolean {
		return this.boxCount > 0;
	}

	//=================================================================================
	/** no overwrite AddOn one 
    public getData() : any {
        //var data = super.getData()
        return data
    }
    public parse(data: any) {
        //super.parse(data)
    }
    */
	//=================================================================================

	public getPlanVasCode(): string {
		let vasCode;
		if (this.isAddOnSelected()) {
			vasCode = this.getBaseVasCode() + '';
			return vasCode;
		} else {
			return '';
		}
	}
}
